
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PatientInsurance',
  props: ['patient'],
  data: () => ({
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        title: 'Priority',
        align: 'start',
        sortable: false,
        key: 'priority',
      },
      { title: 'Company', key: 'companyName' },
      { title: 'Policy Number', key: 'policyNumber' },
      { title: 'Contact', key: 'contact' },
      { title: 'Contact Number', key: 'contactNumber' },
      { title: 'Actions', key: 'actions', sortable: false },
    ],
    patientInsurances: [],
    editedIndex: -1,
    editedItem: {
      priority: '',
      companyName: '',
      policyNumber: '',
      contact: '',
      contactNumber: ''
    },
    defaultItem: {
      priority: '',
      companyName: '',
      policyNumber: '',
      contact: '',
      contactNumber: ''
    },
  }),

  computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Add New Insurance' : 'Edit'
      },
    },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
  },

  created () {
    if (!this.patient){
      return
    }
    this.initialize()
  },
  methods: {
    initialize () {
      this.patientInsurances = [
        {
          priority: '1',
          companyName: 'Jamz Health Plans',
          policyNumber: 'JHP-123',
          contact: 'Paige',
          contactNumber: '01-2349876'
        },
        {
          priority: '2',
          companyName: 'Jamz Premium Health Plans',
          policyNumber: 'JPHP-999',
          contact: 'Prue',
          contactNumber: '04-9999876'
        }
      ]
    },

    editItem (item) {
      this.editedIndex = this.patientInsurances.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      this.editedIndex = this.patientInsurances.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      this.patientInsurances.splice(this.editedIndex, 1)
      this.closeDelete()
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.patientInsurances[this.editedIndex], this.editedItem)
      } else {
        this.patientInsurances.push(this.editedItem)
      }
      this.close()
    },
  },
})
